// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"blog_blogContainer__5RjCa"};